import {checkCookie} from '../utils/cookies';

export default function submitUserInfoToEtracker() {
    if (!window.et_eC_Wrapper) {
        return;
    }

    const etAccountKey = window.etAccountKey ? window.etAccountKey : '4aKeFx';

    // eslint-disable-next-line prefer-const
    let trackingData = {et_et: etAccountKey, et_seg2: checkCookie('juve_login_session') ? 'ja' : 'nein'};

    const userLoginRawdata = localStorage.getItem('userLoginData');
    if (userLoginRawdata) {
        const userLoginData = JSON.parse(userLoginRawdata);
        if (userLoginData) {
            if (userLoginData.productids) {
                trackingData.et_seg3 = Object.values(userLoginData.productids);
            }
            if (userLoginData.accountid) {
                trackingData.et_seg4 = userLoginData.accountid;
            }
        }
    }

    window.et_eC_Wrapper(trackingData);
}
